// extracted by mini-css-extract-plugin
export default {"nearDeadlineRow":"RepairmenList_nearDeadlineRow__so+rP","expiredDeadlineRow":"RepairmenList_expiredDeadlineRow__tRjsN"};